<template>
  <div>
    <div id="actions">
      <a-button type="primary" @click="fetch">
        <a-icon type="reload" /> Làm mới
      </a-button>
    </div>
    <br>
    <a-card title="Service Infomation" class="root-card" :loading="serviceMetricsLoading">
      <div style="display: flex; gap: 16px;">
        <div style="flex: 1; border: 1px solid #d9d9d9; padding: 16px;">
          <a-card :bordered="false">
            <template #title>
              <div style="display: flex; align-items: center;">
                <IconCpu/>&nbsp;
                <span style="font-weight: bold;">CPU</span>
              </div>
            </template>
            <span><i style="font-size: 30px">{{serviceMetrics.cpu}}</i>%</span>
          </a-card>
        </div>
        <div style="flex: 1; border: 1px solid #d9d9d9; padding: 16px;">
          <a-card :bordered="false">
            <template #title>
              <div style="display: flex; align-items: center;">
                <IconRam/>&nbsp;
                <span style="font-weight: bold;">Memory</span>
              </div>
            </template>
            <span><i style="font-size: 30px">{{serviceMetrics.memory}}</i>%</span>
          </a-card>
        </div>
        <div style="flex: 1; border: 1px solid #d9d9d9; padding: 16px;">
          <a-card :bordered="false">
            <template #title>
              <div style="display: flex; align-items: center;">
                <a-icon type="clock-circle" style="margin-right: 8px;" />
                <span style="font-weight: bold;">Uptime</span>
              </div>
            </template>
            <span><i style="font-size: 30px">{{(serviceMetrics.uptime / 3600).toFixed(2)}}</i>h</span>
          </a-card>
        </div>
        <div style="flex: 1; border: 1px solid #d9d9d9; padding: 16px;">
          <a-card :bordered="false">
            <template #title>
              <div style="display: flex; align-items: center;">
                <a-icon type="build" style="margin-right: 8px;" />
                <span style="font-weight: bold;">Build ID</span>
              </div>
            </template>
            <span><b style="font-size: 25px">{{buildInfo.id}}</b></span>
          </a-card>
        </div>
        <div style="flex: 1; border: 1px solid #d9d9d9; padding: 16px;">
          <a-card :bordered="false">
            <template #title>
              <div style="display: flex; align-items: center;">
                <a-icon type="history" style="margin-right: 8px;" />
                <span style="font-weight: bold;">Build Time</span>
              </div>
            </template>
            <span><i style="font-size: 23px">{{new Date(buildInfo.time).toLocaleString()}}</i></span>
          </a-card>
        </div>
      </div>
    </a-card>
    <br>
  </div>
</template>

<style>
.root-card > .ant-card-body {
  padding-bottom: 0px;
}

.root-card > .ant-card-head {
  background: #fafafa;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import IconRam from '../icons/IconRam.vue';
import IconCpu from '../icons/IconCpu.vue';

export default {
  name: 'HomePage',
  components: {
    IconRam,
    IconCpu,
  },
  data() {
    return {
      serviceMetricsLoading: false,
      serviceMetrics: {
        cpu: 0,
        memory: 0,
        uptime: 0,
      }
    }
  },
  computed: {
    ...mapGetters('serviceActuator', {
      buildInfo: "getBuildInfo"
    }),
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions('serviceActuator', {
      getMetrics: "getMetrics"
    }),

    async fetchServiceMetrics() {
      this.serviceMetricsLoading = true;
      const metrics = await this.getMetrics();

      this.serviceMetrics = {
        cpu: metrics.cpu,
        memory: metrics.memory,
        uptime: metrics.uptime,
      }
      this.serviceMetricsLoading = false;
    },

    async fetch() {
      await this.fetchServiceMetrics();
    }
  }
}
</script>